import Lottie from 'react-lottie';
import { useInView } from 'react-intersection-observer';

//components
import {
  MirandaBrandButton,
  MirandaBrandHollowButton,
} from '@/components/Button/BaseButton';

//styles
import {
  HeroWrapper,
  ContainerLogo,
  ContainerHero,
  TopLogoWrapper,
  ContentHolder,
  MediaHolder,
  TagSlogan,
  HeroTitle,
  HeroContent,
  CTAHolder,
  BrandButton,
  BrandHollowButton,
} from './Hero.styles';

//assets
import ShipperGuideLogo from '@/public/images/logos/shipperguide-logo-white.svg';
import AnimationData from '@/datafiles/lottie/shipperguide/hero-animation.json';

const lottieDefaultOptions = {
  loop: false,
  autoplay: true,
  animationData: AnimationData,
};

export function Hero() {
  const { ref, inView } = useInView({
    threshold: 0,
  });

  return (
    <>
      <HeroWrapper inView={inView}>
        <ContainerLogo>
          <TopLogoWrapper>
            <ShipperGuideLogo alt="ShipperGuide" />
          </TopLogoWrapper>
        </ContainerLogo>
        <ContainerHero>
          <ContentHolder>
            <TagSlogan>MOVE MORE WITH LESS</TagSlogan>
            <HeroTitle>
              Your multimodal freight <strong>procurement</strong> &amp;{' '}
              <strong>execution</strong> tool.
            </HeroTitle>
            <HeroContent>
              Grow your business and optimize operations with ShipperGuide.
              Discover and manage rates with any provider of choice, easily
              tender shipments and share real-time tracking with customers and
              your team.
            </HeroContent>
            <CTAHolder>
              <BrandButton as="a" href="#hubspot-form">
                REQUEST A DEMO
              </BrandButton>
              <BrandHollowButton
                as="a"
                target="_blank"
                rel="noopener noreferrer"
                href={`${process.env.SHIPPERGUIDE_URL}/signup`}
              >
                TRY SHIPPERGUIDE NOW
              </BrandHollowButton>
            </CTAHolder>
          </ContentHolder>
          <MediaHolder ref={ref}>
            {inView && <Lottie options={lottieDefaultOptions} />}
          </MediaHolder>
        </ContainerHero>
      </HeroWrapper>
    </>
  );
}
